import { motion } from "framer-motion";

const EASE = [0.22, 1, 0.36, 1];

export const Reveal = ({ children, delay = 0, y = 36, className = "" }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-60px" }}
    transition={{ duration: 0.6, ease: EASE, delay }}
  >
    {children}
  </motion.div>
);

export const Accent = ({ children }) => (
  <span className="font-playfair italic font-medium text-[#F2C230]">{children}</span>
);

export const SectionHead = ({ eyebrow, title, text, align = "left" }) => (
  <div className={align === "center" ? "text-center mx-auto max-w-2xl" : "max-w-2xl"}>
    <Reveal>
      <p className="eyebrow">{eyebrow}</p>
    </Reveal>
    <Reveal delay={0.08}>
      <h2 className="font-sora text-3xl sm:text-4xl lg:text-[2.75rem] font-bold tracking-tight leading-[1.12] mt-4">
        {title}
      </h2>
    </Reveal>
    {text && (
      <Reveal delay={0.16}>
        <p className="text-base text-[#F5F5F0]/65 leading-relaxed mt-5">{text}</p>
      </Reveal>
    )}
  </div>
);

export { EASE };
